import { render, staticRenderFns } from "./extra-it-ticket-freigabe.vue?vue&type=template&id=7afbf2fc&lang=pug&"
import script from "./extra-it-ticket-freigabe.vue?vue&type=script&lang=js&"
export * from "./extra-it-ticket-freigabe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports